import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {userFields} from '../../../../data/shared/fragments';
import Section from './section';
import FollowersCard from '../../../../shared/library/cards/followers';
import {MobileContext} from '../../../../shared/enhancers/mobile-enhancer';
import {PopperOffsetContext} from '../../../../shared/library/popovers/base-v2';

export const query = gql`
  query followers($id: ID!, $first: Int, $after: String) {
    company(id: $id) {
      id
      followers(first: $first, after: $after) {
        count
        edges {
          node {
            ...userFields
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
  ${userFields}
`;

const calcOffset = idx => {
  if (idx > 0 && idx % 9 > 6) {
    return '-85px, 0';
  }
  return '85px,0';
};

const Followers = ({companyId, count}) => {
  const isMobile = useContext(MobileContext);
  return (
    <Section
      title="Followers"
      count={count}
      query={query}
      dataKey="followers"
      variables={{id: companyId}}
      gridCols={isMobile ? 4 : 9}
      initialPageSize={isMobile ? 12 : 9 * 3}
      pageSize={9 * 3}
    >
      {({edges}) => {
        return edges
          ? edges.map((e, idx) => (
              <PopperOffsetContext.Provider key={e.node.id} value={calcOffset(idx)}>
                <FollowersCard user={e.node} isMobile={isMobile} />
              </PopperOffsetContext.Provider>
            ))
          : null;
      }}
    </Section>
  );
};

Followers.propTypes = {
  companyId: PropTypes.any.isRequired,
  count: PropTypes.number.isRequired
};

export default Followers;
